import { getReq } from './axios';
var BASE_URL = "".concat(apiUrl, "/municipality");
export var getAllMunicipality = function getAllMunicipality(params) {
  return getReq(BASE_URL, {
    params: params
  });
};